
// mixins
import OpendataModuleMixin from "@/mixins/opendata-module.mixin";
import TypesMixin from "vue-typed-mixins";
import SplitViewMixin from "@/mixins/split-view";
import MapFilterMixin from "@/mixins/map-filter-buttons";
import { mapState, mapMutations, mapGetters } from "vuex";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import portal from "@vacancorp/portal";
import { PcDataType as DataType } from "@/components/maps-view/@types/split-view";
// tools
import { Hooper, Slide, Pagination as HooperPagination } from "hooper";
import { sendCardImpression } from "@/util/analytics.helper";
import PlaceCategoryMixin2 from "@/mixins/filter-genre.mixin";
import { hasAccessToken, vacancyErrorBannerBtnClicked, showVacancyErrorBannerTitle } from "@/mixins/common-functions";
import New3MapTypeBtnMixin from "@/mixins/new-3-map-type-btn";
//components
import ProgressBar from "@/components/progress-bar.vue";
import VacancyErrorBanner from "@/components/common/vacancy-error-banner.vue";
import BlackLayout from "@/layouts/black-layout.vue";
import NoShopBanner from "@/components/common/no-shop-banner.vue";
import CardView from "@/components/maps-view/card-view.vue";
import NavigationBottom from "@/components/navigation-bottom-pc.vue";
import TopViewMenuHeader from "@/components/top-view/top-view-menu-header.vue";
import TopAreaView from "@/views/top-area-view.vue";
import FilterList from "@/components/filters/filter-list.vue";
import FilterButton from "@/components/filters/filter-button.vue";
import MenuView from "@/views/menu-view.vue";
import FilterPage from "@/views/filter-page.vue";
import { PropType } from "vue";
import Spinner from "@/components/common/spinner.vue";
import MapViewSearchBtn from "./map-view-search-btn.vue";

const CARD_MARGIN = 15;

export default TypesMixin(
  SplitViewMixin,
  MapFilterMixin,
  PlaceCategoryMixin2,
  New3MapTypeBtnMixin,
  OpendataModuleMixin,
).extend({
  name: "component-pc-split-view",
  mixins: [SplitViewMixin, MapFilterMixin, PlaceCategoryMixin2, New3MapTypeBtnMixin, OpendataModuleMixin],
  components: {
    MapViewSearchBtn,
    ProgressBar,
    Spinner,
    VacancyErrorBanner,
    BlackLayout,
    FilterPage,
    NoShopBanner,
    MenuView,
    CardView,
    NavigationBottom,
    TopViewMenuHeader,
    TopAreaView,
    Hooper,
    Slide,
    HooperPagination,
    FilterList,
    FilterButton,
  },
  props: {
    isSearchAgain: Boolean,
    placeList: Array as PropType<portal.PublicPlaceWithVacancyId[]>,
  },
  data(): DataType {
    return {
      iconTextOn: true,
      hoveredPlaceIdHash: "",
      placeListOnCards: [],
      amountOfPlaceListOnCards: 20,
      pagerOfPlaceListOnCards: 1,
      currentCardIndex: 0,
      isGMapInAction_duplicate: false,
      showPlaceCategoryList: false,
      hideAreaBar: false,
      loadingPlacesToCards: false,
      blackLayoutClicked: false,
    };
  },
  watch: {
    placeList(newVal: portal.PublicPlaceWithVacancyId[]) {
      this.placeListOnCards = newVal.slice(0, this.numberOfPlaceListOnCards);
    },
    $selectedGenre(pGenre: PortalAdapterApi.PlaceCategoryType | "all") {
      this.setupGenreFilterButton(this.filterButtons, pGenre);
    },
    $selectedTopPlace(place: undefined | PortalAdapterApi.TopArea) {
      if (place === undefined || !place.areaName) return;
      this.assignAreaButton(place);
    },
    $showLoadingCard(value: boolean) {
      if (value) {
        // move up list to tp
        const list: HTMLElement | null = document.querySelector("#views-list");
        if (list === null) return;
        list.scrollTop = 0;
      }
    },
    isGMapInAction(newValue: boolean) {
      this.isGMapInAction_duplicate = newValue;
      this.iconTextOn = false;
    },
    currentCardIndex(newIndex: number) {
      if (newIndex >= this.numberOfPlaceListOnCards) {
        if (!this.loadingPlacesToCards) this.addPagerOfPlaceListOnCards();
      }
      setTimeout(() => {
        const place: portal.PublicPlaceWithVacancyId | undefined = this.$store.state.data.sortedPlaceList[newIndex];
        if (place === undefined) return;
        sendCardImpression(place, `/${place.placeIdHash}`, this.$gtag);
      }, 100);
    },
    // if placeListOnCards added
    numberOfPlaceListOnCards(newVal: number) {
      this.loadingPlacesToCards = true;
      this.placeListOnCards = this.$store.state.data.sortedPlaceList.slice(0, newVal);
      this.loadingPlacesToCards = false;
    },
    // update filterButtons for virtualDOM to update UI
    selectedFilterRadioButtons(buttons: string[]) {
      const hasVacant = buttons.includes("vacant");
      this.setFilterButtonSelected("vacant", hasVacant);
      const hasFavorite = buttons.includes("favorite");
      this.setFilterButtonSelected("favorite", hasFavorite);
    },
  },
  computed: {
    ...mapState("ui", ["vacancyErrorBannerShown"]),
    ...mapGetters("data", ["isPlaceListNoData", "isNotNormalMap"]),
    isPollSearchBtn(): boolean {
      return this.$selectedGenre === "polling-place";
    },
    showVacancyErrorBannerTitle(): string {
      return showVacancyErrorBannerTitle();
    },
    showBlackLayout(): boolean {
      return this.$menuPanelShown || this.routeIsTop || this.$showTopAreaList || this.showPlaceCategoryList;
    },
    routeIsTop(): boolean {
      return this.$route.path.includes("/top");
    },
    numberOfPlaceListOnCards: {
      get(): number {
        const result = this.pagerOfPlaceListOnCards * this.amountOfPlaceListOnCards;
        return result < this.placeList.length ? result : this.placeList.length;
      },
    },
  },
  created() {
    this.watchSelectedPlaceIdHash();
    this.$once("hook:mounted", () => {
      this.listenListSroll();
      this.setupGenreAreaFilterBtn();
    });
    this.$once("hook:beforeDestroy", () => {
      this.removeListSroll();
    });
  },
  methods: {
    ...mapMutations("data", ["setSelectedFilterRadioButtons"]),
    searchBtnClicked() {
      this.$emit("search-btn-clicked");
    },
    pollSearchBtnClicked() {
      console.log(`pc poll-search-btn-clicked`);
      this.$emit("poll-search-btn-clicked");
    },
    vacancyErrorBannerBtnClicked() {
      vacancyErrorBannerBtnClicked();
    },
    setupGenreAreaFilterBtn() {
      setTimeout(() => {
        if (this.$selectedGenre) {
          this.setupGenreFilterButton(this.filterButtons, this.$selectedGenre);
        }
        this.checkAreaButton();
      }, 500);
    },
    checkAreaButton() {
      this.selectAreaFilterButtonMixin(this.$selectedTopPlace);
      this.assignAreaButton(this.$selectedTopPlace);
    },
    assignCurrentLocationIcon() {
      this.$emit("assign-current-location-icon");
    },
    closeFilterPanel() {
      this.showPlaceCategoryList = false;
      this.blackLayoutClicked = false;
    },
    hideBlackLayout() {
      this.blackLayoutClicked = true;
      this.setShowTopAreaList(false);
      this.closeMenu();
      setTimeout(() => {
        this.showPlaceCategoryList = false;
      }, 100);
    },
    filterBtnClicked(whichBtn: string) {
      if (whichBtn === "area") {
        this.setShowTopAreaList(true);
        return;
      }
      if (whichBtn === "genre") {
        this.showPlaceCategoryList = true;
        this.hideAreaBar = true;
        return;
      }
      if (whichBtn === "tune") {
        this.showPlaceCategoryList = true;
        this.hideAreaBar = false;
        return;
      }
      if (whichBtn === "favorite" && !hasAccessToken()) {
        return this.$store.commit("ui/setFavoritePrompt", true);
      }
      // toggle filter
      if (this.hasSelectedFilter(whichBtn)) {
        const index: number = this.selectedFilterRadioButtons.findIndex((category: string) => category === whichBtn);
        if (index >= 0) {
          const list = [...this.selectedFilterRadioButtons];
          list.splice(index, 1);
          this.setSelectedFilterRadioButtons(list);
        }
      } else {
        const list = [...this.selectedFilterRadioButtons];
        list.push(whichBtn);
        this.setSelectedFilterRadioButtons(list);
      }
      // send request
      setTimeout(() => {
        let query: { [Key: string]: number } = {};
        this.selectedFilterRadioButtons.forEach((filterBtnName: string) => {
          query[filterBtnName] = 1;
        });
        this.$emit("filter-btn-clicked");
      }, 100);
    },
    /** @remarks listen for scrolling list automaticaly */
    handleListScroll(e: any) {
      if (e.target === null) return;

      this.iconTextOn = false;
      const scrolledY = e.target.scrollTop;
      const list: HTMLElement | null = document.querySelector("#views-list");

      if (list === null) return;

      const listClientHeight: number = list.clientHeight;
      const listScrollHeight: number = list.scrollHeight;

      if (Math.abs(scrolledY + listClientHeight - listScrollHeight) < 50) {
        this.currentCardIndex = this.numberOfPlaceListOnCards;
      }
    },
    listenListSroll() {
      const list: HTMLElement | null = document.querySelector("#views-list");
      if (list === null) return;
      (<any>list).addEventListener("scroll", this.handleListScroll, {
        passive: true,
      });
    },
    removeListSroll() {
      const list: HTMLElement | null = document.querySelector("#views-list");
      if (list === null) return;
      (<any>list).removeEventListener("scroll", this.handleListScroll, {
        passive: true,
      });
    },
    scrollCardsUpOnList(selectedPlaceIdHash: string) {
      const list: HTMLElement | null = document.querySelector("#views-list");
      if (list === null) return;

      const targetIndex: number = this.placeList.findIndex((place) => place.placeIdHash === selectedPlaceIdHash);
      if (targetIndex < 0) return;

      this.currentCardIndex = targetIndex < 0 ? 0 : targetIndex;

      if (targetIndex >= this.numberOfPlaceListOnCards) {
        setTimeout(() => {
          this.doMoveCardsUpOnList(targetIndex, list);
        }, 1050);
      } else {
        this.doMoveCardsUpOnList(targetIndex, list);
      }
    },
    doMoveCardsUpOnList(targetIndex: number, list: HTMLElement) {
      const card: HTMLElement | null = document.querySelector(`#views-list .card-view:nth-child(${targetIndex + 1})`);
      if (card === null) return;
      const offsetTop = card.offsetTop;
      // list.scrollTop = offsetTop - CARD_MARGIN;
      list.scroll({
        top: offsetTop - CARD_MARGIN,
        left: 0,
        behavior: "smooth",
      });
    },
    watchSelectedPlaceIdHash() {
      this.$watch(
        () => {
          return this.$store.state.data.selectedPlaceIdHash;
        },
        (newValue: string) => {
          this.scrollCardsUpOnList(newValue);
        },
      );
    },
    mouseHoverCard(placeIdHash: string) {
      this.hoveredPlaceIdHash = placeIdHash;
      this.$emit("enlarge-specified-marker-UI", placeIdHash);
    },
    mouseLeaveCard(_: string) {
      this.hoveredPlaceIdHash = "";
    },
    addPagerOfPlaceListOnCards() {
      setTimeout(() => {
        // for showing animation
        this.pagerOfPlaceListOnCards =
          this.currentCardIndex % this.amountOfPlaceListOnCards === 0
            ? Math.ceil(this.currentCardIndex / this.amountOfPlaceListOnCards) + 1
            : Math.ceil(this.currentCardIndex / this.amountOfPlaceListOnCards);
      }, 1000);
    },
    /** @remarks place and vacancyStatus */
    getVacancyObjectByPlaceIdHash(idHash: string): PortalAdapterApi.ResponseGetMergedDisplayVacancy {
      return this.$store.getters["data/getVacancyObjectByPlaceIdHash"](idHash);
    },
  },
});
